import { render, staticRenderFns } from "./icon-configurator-energy-compatibility-2.svg?vue&type=template&id=99f3ce52&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports